import { render, staticRenderFns } from "./DisqualificationTemplate.vue?vue&type=template&id=2c69ad33"
import script from "./DisqualificationTemplate.vue?vue&type=script&lang=js"
export * from "./DisqualificationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports